import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogPriorityDropdownContentWireframe from '../../VeltCommentDialogPriorityDropdownContentWireframe/VeltCommentDialogPriorityDropdownContentWireframe';
import VeltCommentDialogPriorityDropdownTriggerWireframe from '../../VeltCommentDialogPriorityDropdownTriggerWireframe/VeltCommentDialogPriorityDropdownTriggerWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
;
var VeltCommentDialogPriority = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogPriority.Content = VeltCommentDialogPriorityDropdownContentWireframe;
VeltCommentDialogPriority.Trigger = VeltCommentDialogPriorityDropdownTriggerWireframe;
export default VeltCommentDialogPriority;
